import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

export interface SidebarMenuTopGroupItem {
  labelTranslationKey: string;
  children: SideBarNestedMenuItem[];
  icon: OverridableComponent<SvgIconTypeMap>
}

export interface SidebarMenuTopNavigationItem {
  labelTranslationKey: string;
  navigation: string;
  icon: OverridableComponent<SvgIconTypeMap>
}

export type SideBarTopMenuItem = SidebarMenuTopGroupItem | SidebarMenuTopNavigationItem

export interface SideBarNestedMenuItem {
  labelTranslationKey: string;
  navigation: string;
}

export const getItemNavigation = (item: SideBarTopMenuItem): string => {
  return Object.prototype.hasOwnProperty.call(item, 'navigation') ? (item as SidebarMenuTopNavigationItem).navigation : '';
};

export const getItemChildren = (item: SideBarTopMenuItem): SideBarNestedMenuItem[] => {
  return Object.prototype.hasOwnProperty.call(item, 'children') ? (item as SidebarMenuTopGroupItem).children : [];
}
